<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData"
  [nextOffset]="nextOffset" [previousOffset]="previousOffset" (offset)="getData($event)"
  (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [dataLoaded]="dataLoaded">
</app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Auto Closure</div>
  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
        (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of ttypes" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="time"
        placeholder="Ticket Closure Time (After Resolved)"></textarea>
    </div>

    <mat-slide-toggle (toggleChange)="spocChange()" [checked]="spocChecked"> <b class="blue"> Is Awaiting Ticket Closure
        Required </b>
    </mat-slide-toggle>

    <div class="form-group" *ngIf="isSpocChange">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="awatingTime"
        placeholder="Awaiting Ticket Closure Time"></textarea>
    </div>

    <div class="form-group" *ngIf="isSpocChange">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="awatingCalTypedesc"
        (change)="onawatingCalTypeChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of awatingCalTypes" [value]="ticket.id">{{ticket.awatingCalTypeDesc}}</option>
      </select>
    </div>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
 

<notifier-container></notifier-container>